import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Notification } from '../../common/notification'
import { SelectCurrencyUnit } from '../../common/selectCurrencyUnit'
import { SCREEN } from '../../common/selectCurrencyUnit/constant'
import {
  changeAllowSetDefaultUnit,
  selectAllowSetDefaultUnit,
} from '../../common/selectCurrencyUnit/slice'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../utils/authorization'
import { COMPANY_TYPES } from '../../utils/common'
import { Layout } from '../Layout'
import { CompanyInfo } from '../common/header/companyInfo'
import useCheckIsCompanyType from '../common/header/companyInfo/useCheckIsCompanyType'
import { Filter } from '../common/header/filterBar'
import './lang/i18n'
import { PremiumUserContent } from './premiumUserContent'
import { selectIsLoading as selectIsLoadingFA } from './premiumUserContent/financialAnalysis/store/slice'
import {
  selectIsLoading as selectIsLoadingFS,
  selectYear,
} from './premiumUserContent/financialStatement/store/slice'
import { StandardUserContent } from './standardUserContent'

const PeerAnalysis = () => {
  const screen = SCREEN.PEER_ANALYSIS

  const isUnavailable = useCheckIsCompanyType([
    COMPANY_TYPES.FUNDS,
    COMPANY_TYPES.INSURANCE,
  ])

  const dispatch = useDispatch()
  const userType = useSelector(selectUserType)
  const AUTHORIZATION = useSelector(selectComponentAuthorized)

  const isAllowedUser =
    AUTHORIZATION.companyAnalysis.peerAnalysis[userType.userTypeId] ===
    AUTHORIZATION_TYPE.ALLOW

  const isLoadingFA = useSelector(selectIsLoadingFA)
  const isLoadingFS = useSelector(selectIsLoadingFS)
  const selectedYear = useSelector(selectYear)
  const allowSetDefaultUnit = useSelector(selectAllowSetDefaultUnit(screen))

  useEffect(() => {
    if (!isLoadingFA && (!isLoadingFS || !selectedYear)) {
      dispatch(changeAllowSetDefaultUnit({ screen, value: false }))
    }
  }, [isLoadingFA, isLoadingFS])

  const renderTopComponent = () => {
    return isAllowedUser && <CompanyInfo />
  }

  const renderStickyComponent = () => {
    if (!isUnavailable) {
      return (
        isAllowedUser && (
          <Filter renderRight={() => <SelectCurrencyUnit screen={screen} />} />
        )
      )
    }
  }

  const renderBottomComponent = () => {
    if (isUnavailable) {
      return (
        <Notification
          isI18n
          value="errorCommon.COMPANY_TYPE_ERROR"
          style={{ fontSize: 20 }}
        />
      )
    }

    return isAllowedUser ? <PremiumUserContent /> : <StandardUserContent />
  }

  return (
    <Layout
      isLoadingContent={isAllowedUser && !isUnavailable && allowSetDefaultUnit}
      renderTopComponent={renderTopComponent}
      renderBottomComponent={renderBottomComponent}
      renderStickyComponent={renderStickyComponent}
      isShowFooter={false}
    />
  )
}

export default PeerAnalysis
